import Vue from 'vue'
import AccountAddCredit from './AccountAddCredit.vue'
import AccountAdd from './AccountAdd.vue'
import AccountSubTransactions from './AccountSubTransactions.vue'
import AccountSubTransferCredit from './AccountSubTransferCredit.vue'

const OpenAccountAddCreditComponent = Vue.extend(AccountAddCredit)
const OpenAccountAddComponent = Vue.extend(AccountAdd)
const OpenAccountSubTransactionsComponent = Vue.extend(AccountSubTransactions)
const OpenAccountSubTransferCreditComponent = Vue.extend(AccountSubTransferCredit)

export default {
  openAccountAddCredit (propsData) {
    return new OpenAccountAddCreditComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openAccountAdd (propsData) {
    return new OpenAccountAddComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openAccountSubTransactions (propsData) {
    return new OpenAccountSubTransactionsComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openAccountSubTransferCredit (propsData) {
    return new OpenAccountSubTransferCreditComponent({
      el: document.createElement('div'),
      propsData
    })
  }
}



// WEBPACK FOOTER //
// ./client/components/finances/account.js